import React, {useContext, useEffect, useState} from 'react';
import moment from 'moment';
import usePrevious from '../../../customHooks/usePrevious';

import {AppContext} from '../../../AppModule/Context';

import AiBotIcon from '../../../assets/svgComponents/AiBotIcon';
import AiHandoffStartedChatMsgComponent from '../aiHandoffStartedChatMsgComponent/aiHandoffStartedChatMsgComponent';
import AnimatedStopButton from '../../common/genericComponents/animatedStopButton';
import AutoTextTyperComponent from '../../common/genericComponents/autoTextTyperComponent';
import HandoffToAgentBtnComponent from '../handoffToAgentBtnComponent/handoffToAgentBtnComponent';

import aiCompletionService from '../../../services/restServices/aiCompletionService';
import expertHomeService from '../../../services/expertHomeService';
import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import '../aiChatMsgContentWrapperComponent/aiChatMsgContentWrapperComponent.css';
import './aiChatMsgComponent.css';
import NotificationAiBotIcon from '../../../assets/svgComponents/NotificationAiBotIcon';

const OONI_AI_ACTION_MESSAGES = {
  [VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_PENDING]:
    VIDABOO_CONSTANTS.AI_BOT_NAME + ' AI',
  [VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_FAILURE]:
    "It looks like I couldn't generate a response.",
  [VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_STOPPED]:
    'Oops, looks like we had to stop mid-way - want to give it another shot?',
};

const AiChatMsgComponent = ({
  isDemo = false,
  isMentorSide = true,
  showAnimatedBorder = false,
  chatMessageDto = {},
  chatRoomDto = {},
  chatRowOptionsElement = null,
  currentlyActiveOoniChatMsg = {},
  lastOoniChatMsg = {},
  mentorDto = {},
  senderObjectId = null,
  senderObjectType = null,
  widgetId = '',
  getTextMessage = () => {},
}) => {
  const context = useContext(AppContext);

  const [ooniAiAction, setOoniAiAction] = useState(null);
  const [isStopCompletionFlowRunning, setIsStopCompletionFlowRunning] =
    useState(false);
  const [isTextAnimationDisable, setIsTextAnimationDisable] = useState(true);
  const [chatMsgTime, setChatMsgTime] = useState(null);

  const prevOoniAiAction = usePrevious(ooniAiAction);

  const shouldStopCompletionWork =
    ooniAiAction === VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_PENDING &&
    chatMessageDto.chatMessageId === currentlyActiveOoniChatMsg?.chatMessageId;
  const showHandoffComponent =
    ooniAiAction === VIDABOO_CONSTANTS.OONI_AI_ACTIONS.HANDOFF_FLOW_START;

  useEffect(() => {
    updateOoniAiAction();
  }, [chatMessageDto]);

  useEffect(() => {
    if (
      prevOoniAiAction &&
      prevOoniAiAction !== ooniAiAction &&
      ooniAiAction !== VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_PENDING
    ) {
      setIsTextAnimationDisable(false);
    } else {
      setIsTextAnimationDisable(true);
    }
  }, [ooniAiAction]);

  useEffect(() => {
    const msgSendTime = chatMessageDto?.sendTime;
    const chatMsgTime = moment(msgSendTime || undefined).format('D MMMM HH:mm');
    setChatMsgTime(chatMsgTime);
  }, [chatMessageDto?.sendTime]);

  const updateOoniAiAction = () => {
    const ooniAiAction = expertHomeService.getOoniAiAction(chatMessageDto);
    setOoniAiAction(ooniAiAction);
    setIsStopCompletionFlowRunning(false);
  };

  const onStopCompletionBtnClicked = async () => {
    const chatMessageId = chatMessageDto.chatMessageId;
    const metaData =
      expertHomeService.getMetaDataFromChatMessageDto(chatMessageDto);
    const llmCompletionFlowId = metaData.llmCompletionFlowId;
    if (chatRoomDto.roomId && chatMessageId && llmCompletionFlowId) {
      setIsStopCompletionFlowRunning(true);
      await aiCompletionService.stopCompletion(
        chatRoomDto.roomId,
        chatMessageId,
        llmCompletionFlowId,
        isDemo,
      );
    } else {
      const toastObj = utilsService.getToastObj({
        toastTitle: 'Failed to stop request',
        toastType: VIDABOO_CONSTANTS.TOAST_COMPONENT_TYPES.FAILURE,
      });
      context.addToastObj(toastObj);
    }
  };

  return showHandoffComponent ? (
    <AiHandoffStartedChatMsgComponent
      isDemo={isDemo}
      isMentorSide={isMentorSide}
      chatMessageDto={chatMessageDto}
      chatRoomDto={chatRoomDto}
      lastOoniChatMsg={lastOoniChatMsg}
      senderObjectId={senderObjectId}
      senderObjectType={senderObjectType}
      widgetId={widgetId}
      chatRowOptionsElement={chatRowOptionsElement}
      getTextMessage={getTextMessage}
    />
  ) : (
    <div
      className={`et-ai-chat-msg-content-wrapper-container ${!isMentorSide ? 'et-ai-chat-msg-content-wrapper-container-client' : ''} ${shouldStopCompletionWork ? 'et-ai-chat-msg-content-wrapper-container-active' : ''}`}>
      <div className="et-acmcwc-ai-content-msg-time-wrap">
        <div
          className={`et-acmcwc-ai-bot-icon-name-msg-wrap ${showAnimatedBorder || isMentorSide ? 'et-acmcwc-ai-bot-icon-name-msg-wrap-color-border' : ''} 
          ${showAnimatedBorder ? 'et-acmcwc-ai-bot-icon-name-msg-wrap-color-border-animated' : ''}`}>
          {showAnimatedBorder ? (
            <div className="et-acmcwc-abinmw-animated-border" />
          ) : isMentorSide ? (
            <div className="et-acmcwc-abinmw-non-animated-border" />
          ) : null}
          <div
            className={
              showAnimatedBorder
                ? 'et-acmcwc-abinmw-wrap-animated'
                : isMentorSide
                  ? 'et-acmcwc-abinmw-wrap-non-animated'
                  : 'et-acmcwc-abinmw-wrap'
            }>
            {!isMentorSide || shouldStopCompletionWork ? (
              <div className="et-acmcwc-ai-bot-wrap">
                <AiBotIcon isAnimated={shouldStopCompletionWork} />
              </div>
            ) : (
              <div className="et-acmcwc-ai-bot-wrap-mentor">
                <NotificationAiBotIcon />
              </div>
            )}

            <div className="et-acmcwc-ai-bot-name-msg-wrap">
              {!shouldStopCompletionWork && (
                <div className="et-acmcwc-ai-bot-name">
                  {VIDABOO_CONSTANTS.AI_BOT_NAME}
                </div>
              )}
              <AutoTextTyperComponent
                getTextMessage={getTextMessage}
                isAnimationDisable={isTextAnimationDisable}
                text={
                  ooniAiAction ===
                  VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_SUCCESS
                    ? chatMessageDto.messageText
                    : ooniAiAction ===
                        VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_PENDING
                      ? chatMessageDto.chatMessageId ===
                        currentlyActiveOoniChatMsg?.chatMessageId
                        ? OONI_AI_ACTION_MESSAGES[ooniAiAction]
                        : OONI_AI_ACTION_MESSAGES[
                            VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_FAILURE
                          ]
                      : OONI_AI_ACTION_MESSAGES[ooniAiAction]
                }
              />
              {chatRowOptionsElement && (
                <div className="et-acmcwc-ai-msg-chat-row-options">
                  {chatRowOptionsElement}
                </div>
              )}
            </div>
          </div>
        </div>
        <p className="et-acmcwc-ai-msg-time" dir="auto">
          {chatMsgTime}
        </p>
      </div>
      {shouldStopCompletionWork ? (
        <AnimatedStopButton
          isDisabled={isStopCompletionFlowRunning}
          isMentorSide={isMentorSide}
          toolTipTxt="Stop"
          onClick={onStopCompletionBtnClicked}
        />
      ) : (
        !isDemo &&
        !isMentorSide &&
        mentorDto?.appControlDto?.agentHandoffButton &&
        lastOoniChatMsg?.chatMessageId === chatMessageDto.chatMessageId && (
          <HandoffToAgentBtnComponent
            chatRoomDto={chatRoomDto}
            widgetId={widgetId}
          />
        )
      )}
    </div>
  );
};

export default AiChatMsgComponent;
